import * as actionTypes from 'redux/actionTypes'

export const setMaxCompanies = (payload) => {
  return {
    type: actionTypes.SET_MAX_COMPANIES,
    payload,
  }
}
